module.exports = __webpack_public_path__ + "img/description.298a6dcf.svg";